import React, { useState } from 'react';
import { saveLeadEmail } from '../utils/leadCapture';

const EmailCollection = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const validateEmail = (email) => {
    return email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!validateEmail(email)) {
      setStatus('Please enter a valid email address');
      setIsLoading(false);
      return;
    }

    try {
      const result = await saveLeadEmail({ email, marketingConsent: true });
      if (!result.ok) throw new Error(result.error);
      setStatus('Thank you for signing up!');
      setEmail('');
    } catch (error) {
      console.error('Error saving email:', error);
      setStatus('Something went wrong. Please try again.');
    }
    setIsLoading(false);
  };

  return (
    <div className="bg-slate-800 p-6 rounded-lg border border-green-400 max-w-md mx-auto">
      <h3 className="text-xl font-bold text-green-400 mb-4">
        Get Career Updates
      </h3>
      <p className="text-slate-300 mb-4">
        Subscribe to Tekyu career insights and learning updates. You can unsubscribe from any email.
      </p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <input
            type="email"
            aria-label="Email for Tekyu career updates"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="w-full px-4 py-2 bg-slate-700 border border-slate-600 rounded-md text-white focus:outline-none focus:border-green-400"
            disabled={isLoading}
          />
        </div>
        <button
          type="submit"
          disabled={isLoading}
          className={`w-full px-4 py-2 rounded-md font-semibold ${
            isLoading
              ? 'bg-slate-600 cursor-not-allowed'
              : 'bg-green-400 hover:bg-green-500'
          } text-white transition-colors duration-300`}
        >
          {isLoading ? 'Subscribing...' : 'Keep Me Updated'}
        </button>
        {status && (
          <p role="status" className={`text-sm ${
            status.includes('error') || status.includes('Please')
              ? 'text-red-400'
              : 'text-green-400'
          }`}>
            {status}
          </p>
        )}
      </form>
    </div>
  );
};

export default EmailCollection;